import { connect } from 'react-redux';
import { getHotelInfo } from 'src/routes/Hotel/store/hotel';
import FortunaJumbotron from '../../components/FortunaJumbotron';

const mapStateToProps = (state) => ({
  tooltip: getHotelInfo(state),
});

export default connect(mapStateToProps)(FortunaJumbotron);
